import React, { useEffect, useState } from 'react';
import { AlertCircle } from 'lucide-react';

export default function SandboxBanner() {
  const [sandbox, setSandbox] = useState(null);

  useEffect(() => {
    // Detect sandbox environment from URL
    const params = new URLSearchParams(window.location.search);
    const env = params.get('env');
    
    if (env && ['sandbox1', 'sandbox2', 'sandbox3'].includes(env)) {
      setSandbox(env);
      
      // Store in localStorage for persistence
      localStorage.setItem('sandbox_env', env);
    } else {
      // Check localStorage
      const stored = localStorage.getItem('sandbox_env');
      if (stored && ['sandbox1', 'sandbox2', 'sandbox3'].includes(stored)) {
        setSandbox(stored);
      }
    }
  }, []);

  if (!sandbox) return null;

  const sandboxColors = {
    sandbox1: {
      bg: 'bg-mlt-info',
      text: 'text-white',
      name: 'Sandbox 1',
      icon: '🔵'
    },
    sandbox2: {
      bg: 'bg-mlt-success',
      text: 'text-white',
      name: 'Sandbox 2',
      icon: '🟢'
    },
    sandbox3: {
      bg: 'bg-mlt-navy',
      text: 'text-white',
      name: 'Sandbox 3',
      icon: '🟣'
    }
  };

  const config = sandboxColors[sandbox];

  return (
    <div className={`${config.bg} ${config.text} py-2 px-4 sticky top-0 z-50`} data-testid="sandbox-banner">
      <div className="max-w-7xl mx-auto flex items-center justify-between">
        <div className="flex items-center space-x-3">
          <AlertCircle className="w-5 h-5" />
          <span className="font-semibold text-sm">
            {config.icon} Testing Environment: {config.name}
          </span>
        </div>
        <button
          onClick={() => {
            localStorage.removeItem('sandbox_env');
            window.location.href = window.location.origin;
          }}
          className="text-xs underline hover:no-underline"
        >
          Exit Sandbox
        </button>
      </div>
    </div>
  );
}
